import { render, staticRenderFns } from "./PersonIntro.vue?vue&type=template&id=59d5b727&"
import script from "./PersonIntro.vue?vue&type=script&lang=js&"
export * from "./PersonIntro.vue?vue&type=script&lang=js&"
import style0 from "./PersonIntro.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports